<template>  
    <section class="blockElement loginLoader-page" > 
		<div class="container-fluid bglogin p-0">
			<div class="innerInclude">
				<div class="p_login d-flex align-items-center justify-content-center p-0"> 
					
					<div class="row  w-100"> 
						<div class="col-12 col-md-4  text-center d-flex vh_100 flex-wrap blueBG beforeBG justify-content-center align-items-center">
                            <div class="titleArera Loginlogo">
                                <img src="../../../../static/fxView/images/logo-white.svg" alt="Icon">
                            </div>
                            <div class="loginNewSection  ">
                                <div class="loginSpreads d-flex">
                                    <div class="d-flex position-relative InnerLogin">
                                        <div class="loginIcon">
                                            <figure>
                                                <img src="../../../../static/fxView/images/Spreads.png" alt="">  
                                            </figure>                                     
                                        </div>
                                        <div class="LoginContent  text-left">
                                            <h3>Spreads</h3>
                                            <p>from 0.0 pips</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="loginSpreads d-flex ">
                                    <div class="d-flex position-relative InnerLogin">
                                        <div class="loginIcon">
                                            <figure>
                                                <img src="../../../../static/fxView/images/Commission.png" alt="">  
                                            </figure>                                     
                                        </div>
                                        <div class="LoginContent text-right">
                                            <h3>$1 per</h3>
                                            <p>$100K Commission</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="loginSpreads d-flex">
                                    <div class="d-flex position-relative InnerLogin">
                                        <div class="loginIcon">
                                            <figure>
                                                <img src="../../../../static/fxView/images/TradingTools.png" alt="">  
                                            </figure>                                     
                                        </div>
                                        <div class="LoginContent text-left">
                                            
                                            <h3>A variety of </h3>
                                            <p>Trading Tools</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="loginSpreads d-flex ">
                                        <div class="d-flex position-relative InnerLogin">
                                        <div class="loginIcon">
                                            <figure>
                                                <img src="../../../../static/fxView/images/FastExecution.png" alt="">  
                                            </figure>                                     
                                        </div>
                                        <div class="LoginContent text-right">
                                            <h3>Ultra</h3>
                                            <p>Fast Execution</p>
                                            
                                        </div>
                                    </div>
                                </div>
                                <div class="loginSpreads d-flex">
                                    <div class="d-flex position-relative InnerLogin">
                                        <div class="loginIcon">
                                            <figure>
                                                <img src="../../../../static/fxView/images/DepositBonus.png" alt="">  
                                            </figure>                                     
                                        </div>
                                        <div class="LoginContent text-left">
                                            <h3>100%</h3>
                                            <p>Deposit Bonus</p>
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- 
                            <div class="PortfoliosTitle"> 
                                <div id="demo" class="carousel slide fxRegisterSteps " data-ride="carousel"> 
                                    <div class="carousel-inner">
                                        <div class="carousel-item active">
                                            <p>{{ $t('welcomeMsg') }}</p>
                                            <img src="../../../../static/fxView/images/login-download.svg" alt="Banner">
                                            <h3>Competitive Trading Conditions </h3>
                                            <p>Benift from spreads as low as 0.0 pips on major fx pairs, and commission of $1 per $100,000 per side.</p>     
                                        </div>
                                         
                                    </div>
                                    <div class="clearfix"></div> 
                                </div>
                            </div>  -->
                            
                        </div>
						<div class="col-12 col-md-8 text-center d-flex vh_100 align-items-center">
							<div class="sign_insec text-center">
								<div class="subtitle">
									<h3 class="mb-3"> Forgot Password</h3>
									<loader :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></loader>
                            		<message :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message>
								</div>
								<div class="stepForm"> 
									<div class="form-group field-wrapper" >
                                        <div class="position-relative">
    										<input   placeholder=" " type="text" name="Email" v-model="email" class="float-field form-control"  v-validate="'required|email'"   :class="{ 'is-invalid': submitted && errors.has('Email') }" ref="emailInput" />
    										<label for="username" class="float-label">Enter your email address</label> 
                                        </div>
										<p class="error" v-for="error in errors.collect('Email')">{{ error }}</p>
									</div> 
									<div class="clearfix"></div>
									<div class="d-flex justify-content-between align-items-center submitButton w-100">
										<button class="prism_btn btn_sm" v-on:click.prevent="submit()">
											<span v-if="!resend">Reset Password</span> 
											<span v-if="resend">Resend Email</span> 
										</button>
										<div class="forgot_sec">
											<router-link :to="'/'" class="forgotpassword d-flex align-items-center">
												<feather type="chevron-left" size="1rem" class="mr-1"></feather>Back to login page
											</router-link>
										</div>
									</div> 
								</div> 
							</div>
						</div>
					</div> 
				</div>
			</div>
		</div>
    </section> 
</template>
<script>
    import * as types from '@/types'
    import { mapActions } from 'vuex'
    import { fxViewMixins } from '@/plugins/fxView'
    export default {
        name: 'Forgot-password',
        mixins: [fxViewMixins],
        data() {
            return {
                "email" : "",
				resend : false,
                submitted: false,
                pageLoader : false,
                response_msg : '',
                msg_type   : '',      
            }
        },
        methods:{
            ...mapActions({
                _runUserForgotPassword: types.RUN_USER_FORGOT_PASSWORD
            }),
            submit(){
                const _that = this
                _that.submitted = true;
                _that.$validator.validate().then(valid => {
                    if (valid) {
                        let input_json={
                            'globalParams' :{
                                "email": _that.email
                            },
                            'localParams' :{ "parameter" : _that }
                        }
                        _that._runUserForgotPassword(input_json)
                    }else{
                        _that.handleValidationErrorAdvanced(_that.errors)
                    }
                });
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/users/forgot_password.vue